import React from "react";
import { TextField, IconButton, Tooltip, Typography, FormHelperText, Grid2 } from "@mui/material";
import { CloudUpload, Visibility, Delete } from "@mui/icons-material";

const GenericFileUploader = ({
  label = "Upload File",
  fileName = "",
  selectedFile = null,
  onFileChange,
  onPreview,
  onRemove,
  accept = "application/pdf,image/*,video/*",
  // isImage = false,
  // isPdf = false,
  // isVideo = false,
  error = false,
  helperText = "",
  fileSizeError = false,
  videoDurationError = false,
  required = false,
  isSubmitted = false,
  formatFileSize,
  ...props
}) => (
  <Grid2 container spacing={1} alignItems="center">
    <Grid2 item size={12}>
      <TextField
        fullWidth
        variant="outlined"
        size="small"
        placeholder="No file chosen"
        value={fileName}
        sx={{
          backgroundColor: "white",
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: error ? "red" : "rgba(0, 0, 0, 0.23)",
            },
            "&:hover fieldset": {
              borderColor: error ? "red" : "rgba(0, 0, 0, 0.6)",
            },                      
            "&.Mui-focused fieldset": {
              borderColor: error ? "red" : "#06adaf",
            },
          },
          "& .MuiFormLabel-asterisk": {
            color: required ? "red" : "inherit",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#06adaf",
          },
          "& .MuiOutlinedInput-root.Mui-focused fieldset": {
            borderColor: "#06adaf",
          },
        }}
        InputProps={{
          readOnly: true,
          endAdornment: (
            <>
              {selectedFile && (
                <>
                  <IconButton
                    size="small"
                    onClick={onPreview}
                    disabled={!(selectedFile && selectedFile.type.startsWith("image/")) && !(selectedFile && selectedFile.type === "application/pdf") && !(selectedFile && selectedFile.type.startsWith("video/"))}
                  >
                    <Visibility />
                  </IconButton>
                  <IconButton size="small" color="error" onClick={onRemove}>
                    <Delete />
                  </IconButton>
                </>
              )}
              <Tooltip title="Browse" arrow>
                <IconButton
                  color="secondary"
                  component="label"
                  size="medium"
                  fullWidth
                >
                  <CloudUpload />
                  <input
                    type="file"
                    accept={accept}
                    hidden
                    onChange={onFileChange}
                  />
                </IconButton>
              </Tooltip>
            </>
          ),
        }}
        error={error}
        required={required}
        {...props}
      />
      {isSubmitted && !selectedFile && (
        <FormHelperText error>Please select a file to upload</FormHelperText>
      )}
      {fileSizeError && (
        <FormHelperText error>
          File size exceeds the maximum limit of 10MB
        </FormHelperText>
      )}
      {videoDurationError && (
        <FormHelperText error>
          Video duration exceeds the maximum limit of 60 seconds
        </FormHelperText>
      )}
      {helperText && !error && <FormHelperText>{helperText}</FormHelperText>}
      {selectedFile && formatFileSize && (
        <Typography
          variant="caption"
          color={fileSizeError ? "error" : "text.secondary"}
        >
          {formatFileSize(selectedFile.size)}
        </Typography>
      )}
    </Grid2>
    {/* <Grid2 item xs={3} sm={3} md={3} lg={1} xl={1}>
      <Tooltip title="Browse" arrow>
        <IconButton color="secondary" component="label" size="medium" fullWidth>
          <CloudUpload />
          <input type="file" accept={accept} hidden onChange={onFileChange} />
        </IconButton>
      </Tooltip>
    </Grid2> */}
  </Grid2>
);

export default GenericFileUploader;